import { Injectable } from '@angular/core';
import {
  OrderHistoryResponse,
  ResultsDeliveryService,
} from '@compumark/analyst-selection-tool-client';
import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-community';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersDatasourceService {
  constructor(private resultsDeliveryService: ResultsDeliveryService) {}

  createFor(): IServerSideDatasource {
    const r = this.resultsDeliveryService;
    const self = this;
    return {
      getRows(params: IServerSideGetRowsParams): void {
        params.request.filterModel = self.cleanFilterModel(params);
        let dateFrom;
        let dateTo;
        const filterModel = params.request.filterModel as any;
        if (!!filterModel?.date as any) {
          dateFrom = self.parseDate(filterModel?.date?.dateFrom);
          dateTo = self.parseDate(filterModel?.date?.dateTo);

          switch (filterModel?.date?.type) {
            case 'equals': {
              dateTo = dateFrom;
              break;
            }
            case 'lessThan': {
              dateTo = dateFrom;
              dateFrom = undefined;
              break;
            }
            case 'greaterThan': {
              dateTo = undefined;
              break;
            }
          }
        }
        r.getOrderHistory({
          startWith: params.request.startRow!,
          endBefore: params.request.endRow!,
          resultsDeliveryFilter: {
            orderNo: filterModel?.orderNo?.filter,
            searchId: filterModel?.searchId?.filter,
            candidate: filterModel?.trademarkName?.filter,
            productionOrderNo: filterModel?.productionOrderNo?.filter,
            creationDateStart: dateFrom,
            creationDateEnd: dateTo,
            statuses: filterModel?.status?.values,
            turnaroundTimes: filterModel?.turnaroundTime?.values,
            resultsDeliveryId: filterModel?.id?.filter,
          },
        })
          .pipe(first())
          .subscribe((result: OrderHistoryResponse) => {
            params.success({
              rowData: result.orders,
              rowCount: result.totalCount,
            });
          });
      },
    };
  }
  private cleanFilterModel(params: IServerSideGetRowsParams): any {
    const filterModel = params.request.filterModel as any;
    for (const propName in filterModel) {
      if (
        propName === 'status' ||
        propName === 'date' ||
        propName === 'turnaroundTime'
      ) {
        continue;
      }
      if (!filterModel[propName].filter) {
        delete filterModel[propName];
      }
    }
    return filterModel;
  }

  private parseDate(dateToParse: string): string | undefined {
    if (!!dateToParse) {
      const parsedDate = new Date(dateToParse);
      parsedDate.setTime(
        parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60 * 1000,
      );
      return parsedDate.toISOString();
    }
    return undefined;
  }
}
